<template>
  <div id="navigation-bar">
    <template v-if="navInfo.contactId">
      <TopBar @item-click="navTo" />
      <NavBar v-if="showNavBar" @item-click="navTo" />
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { tracker } from '@services';
import TopBar from '@/components/TopBar.vue';
import NavBar from '@/components/NavBar.vue';

export default {
  name: 'NavigationBar',
  components: { NavBar, TopBar },
  props: {
    showLowerNavBar: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showNavBar: true,
    };
  },
  watch: {
    showLowerNavBar: {
      immediate: true,
      handler(val) {
        this.showNavBar = val;
      },
    },
  },
  methods: {
    ...mapActions('main', ['getUserInfo']),
    navTo(item) {
      // If need to track event
      if (item.event) {
        tracker(item.event);
      }
      // If is external link
      if (item.path.includes('http')) {
        window.open(item.path, '_blank');
        return;
      }
      // If logout - logout and redirect to /
      if (item.path === '/logout') {
        window.postMessage({ name: 'iConnectionsEventBus', type: 'logout' }, '*');
        return;
      }

      // If the path has an eventId query param - lets extract and post a message with it!
      if (item.path.indexOf('?') >= 0) {
        const queryParams = item.path.split('?')[1];
        const splitParams = queryParams.split('&');

        const eventId = splitParams.find((param) => param.indexOf('eventId') >= 0);
        if (eventId) {
          window.postMessage({
            name: 'iConnectionsEventBus',
            type: 'eventIdChanged',
            eventId: eventId.split('=')[1],
          }, '*');
        }
      } else {
        window.postMessage({
          name: 'iConnectionsEventBus',
          type: 'eventIdChanged',
          eventId: 0,
        }, '*');
      }

      window.postMessage({ name: 'iConnectionsEventBus', type: 'changeMFe', path: item.path }, '*');
    },
  },
  computed: {
    ...mapGetters('main', ['navInfo']),
  },
  async mounted() {
    await this.getUserInfo();
  },
};
</script>

<style lang="scss" scoped>
</style>
